import { ProductScreenshot } from 'components/ProductScreenshot';
import { CalloutBox } from 'components/Docs/CalloutBox';
import { Tab } from 'components/Tab';
import * as React from 'react';
export default {
  ProductScreenshot,
  CalloutBox,
  Tab,
  React
};